<template>
  <b-container class="text-center">

    <hr>
    <div style="min-width: 350px; max-width: 500px;">
      <table>
        <tr>
          <td>
            <b class="mr-4">Root Passwort: </b>
          </td>
          <td >
            <b class="mr-4"> {{showPassword ? rootPassword : '****************'}}</b>
          </td>
          <td>
            <b-button variant="outline-primary"
                      @click="showPassword = !showPassword">
              <i :class=" showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
            </b-button>
          </td>
        </tr>
      </table>
    </div>
    <hr>
    <div class="mt-4">
      <b-button :class="showConfig ? 'active' : ''  "
                class="mr-2 mb-2"
                @click=" showConfig = !showConfig , showDelete = false, showNewinstallation= false"
                variant="outline-success">
        {{showConfig ? 'Konfiguration abbrechen' : 'Konfiguration'}}
      </b-button>

      <b-button :class="showDelete ? 'active' : ''"
                class="mr-2 mb-2"
                variant="outline-danger"
                @click="showDelete = !showDelete , showNewinstallation = false , showConfig = false">
        {{!showDelete ? 'Vserver Löschen':'Löschen Abbrechen'}}
      </b-button>

      <b-button :class="showNewinstallation ? 'active' : ''"
                class="mr-2 mb-2"
                variant="outline-warning"
                @click="showNewinstallation = !showNewinstallation, showDelete = false , showConfig = false">
        {{showNewinstallation ? 'Installation abbrechen' : 'Vserver neu installieren'}}
      </b-button>
    </div>
    <hr>
    <div v-if="showConfig">
      <b-container>
        <luma-config-vserver></luma-config-vserver>
      </b-container>
    </div>

    <div v-if="showDelete">
      <h1>Vserver wirklich löschen?</h1>
      <b-button @click="$bvModal.show('deleteVserver')">Ja</b-button>
      <b-button @click="showDelete = false">Nein</b-button>
    </div>
    <b-modal id="deleteVserver">
      Bitte geben die Vserver ID ein, um die Löschung zu bestätigen.
      Vserver ID: <b>{{vid}}</b>

        Vserver ID eingeben:

      <hr>
        <b-input  class="col-12"
                  v-model="validation"
                  @keyup.enter="delVserver()"
                  type="number">
        </b-input>
        <br>
        <b-button :disabled="Number(validation) === Number(vid) ? false : true"
                  variant="outline-success"
                  class="col-12"
                  @click="delVserver()">
          Löschen
        </b-button>

        <template v-slot:modal-footer>
          <br>
        </template>

    </b-modal>

    <div v-if="showNewinstallation">
      <h1>Vserver neu installieren</h1>
      <hr>
      <h2 class="mb-4">Betriebssystem wählen</h2>
      <luma-os-selection-vserver></luma-os-selection-vserver>
      <hr>
      <div v-if="os || false">
        <h5>Ausgewältes Betriebssystem:</h5>
        <h4>{{os}}</h4>
        <b-button class="mt-2" @click="$bvModal.show('installVserver')">
          Installation Starten
        </b-button>
      </div>

      <b-modal id="installVserver">
        Bitte geben die Vserver ID ein, um die Neuinstallation zu bestätigen.
        Vserver ID: <b>{{vid}}</b>
        <template v-slot:modal-footer>
          Vserver ID eingeben:
          <b-input v-model="validation" type="number"></b-input>
          <b-button v-show="Number(validation) === Number(vid) ? true : false"
                    variant="outline-success"
                    @click="installVserver()">
            Installation Starten
          </b-button>
        </template>
      </b-modal>
    </div>
  </b-container>
</template>

<script>
    import LumaOsSelectionVserver from "./luma-os-selection-vserver";
    import {PageControl} from "@/store/models/layout/page_control";
    import {Vserver} from "@/store/models/vserver/vserver";
    import LumaConfigVserver from "./luma-config-vserver";


    export default {
        name: "luma-managemnt-vserver",
        components: {LumaConfigVserver, LumaOsSelectionVserver},
        data:()=>({
            validation:null,
            showDelete:false,
            showNewinstallation:false,
            showConfig:false,
            showPassword:false
        }),
        computed:{
            rootPassword(){
                if(!Vserver.find(this.vid)) return 0
                return Vserver.find(this.vid).password
            },
            vid(){
                return this.$route.params.id
            },
            os(){
                if(!PageControl.find(this.vid)) return Vserver.find(this.vid).template
                return PageControl.find(this.vid).osoption || undefined
            }
        },
        methods:{
            delVserver(){
                Vserver.deleteVserver(this.vid)
                this.$router.push({name:'datacenter-view'})
            },
            installVserver(){
                Vserver.newInstallation(this.vid, this.os)

                this.$router.push({name:'datacenter-vserver'})
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datacenter/vserver_datacenter/luma-managemnt-vserver.vue